"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISABLED_BULK_DOWNLOAD_FILE_TYPES = void 0;
const fileFormats_1 = require("../fileFormats");
exports.DISABLED_BULK_DOWNLOAD_FILE_TYPES = [
    fileFormats_1.FileTypeName.COMPRESSION,
    fileFormats_1.FileTypeName.PRESENTATION,
    fileFormats_1.FileTypeName.VIDEO,
];
